<template>
  <a-row class="inner" type="flex" justify="space-between">
    <a-col :span="mainSpan" class="modal-main-content">
      <div class="top-content">
        <div class="top">
          <h2>{{ curQueryObj.title }}</h2>
          <p class="info-row">
            <a-space class="info-item category">
              <a-icon type="folder" />
              <span class="label">{{ curQueryObj.categoryName || "" }}</span>
            </a-space>
            <a-space class="info-item">
              <a-icon type="clock-circle" />
              <span class="label">{{
                curQueryObj.updateDate
                  ? new Date(curQueryObj.updateDate).format("yyyy-MM-dd hh:mm:ss")
                  : ""
              }}</span>
            </a-space>
            <a-space class="info-item">
              <a-button type="link" icon="copy" class="label" @click="copyLink"
                >分享链接</a-button
              >
            </a-space>
            <a-space class="info-item">
              <span class="label">编撰人:</span>
              <span class="label">{{ curQueryObj.editor || "" }}</span>
            </a-space>
          </p>
        </div>
        <div class="watermark" id="watermark"></div>
        <mavon-editor
          class="content"
          :toolbarsFlag="false"
          defaultOpen="preview"
          :value="curQueryObj.content"
          :subfield="false"
          :boxShadow="false"
          :ishljs="true"
          :externalLink="externalLink"
          previewBackground="none"
        />
      </div>

      <div class="operation-row">
        <a-space class="info-item useful" @click="clickLikeBtn(curQueryObj.id, 'like')">
          <a-icon
            type="like"
            :theme="isLikes ? 'filled' : 'outlined'"
            :style="{ color: isLikes ? '#0077FF' : '' }"
          />
          <span class="label">
            <span>有帮助</span>
            {{ curQueryObj.likesNum || 0 }}
          </span>
        </a-space>
        <!-- 新增 无帮助 按钮 -->
        <a-popconfirm :disabled="isUseless" 
          title="辛苦您一分钟宝贵的时间写下无帮助的原因，以便我们更好的改进" 
          ok-text="反馈问题"
          cancel-text="不反馈"
          @confirm="feedback"
          placement="topLeft">
          <a-space class="info-item useless" @click="clickLikeBtn(curQueryObj.id, 'useless')">
            <a-icon
              type="dislike"
              :theme="isUseless ? 'filled' : 'outlined'"
              :style="{ color: isUseless ? '#FAAD14' : '' }"
            />
            <span class="label">
              <span>无帮助</span>
              {{ curQueryObj.useless || 0 }}
            </span>
          </a-space>
        </a-popconfirm>
      </div>
    </a-col>

    <a-col :span="6" class="modal-right-content" v-if="similarList.length">
      <SimilarQuery
        :list="similarList"
        @toDetail="handleToDetail"
      ></SimilarQuery>
    </a-col>
  </a-row>
</template>
<script>
import { getDetailInfo, setLikesOrCancel } from "../../../api/faq";
import SimilarQuery from "./SimilarQuery.vue";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import { debounce } from "../../../utils/common";
import { getCookie } from "@/utils/common";

export default {
  name: "detail-modal",
  props: {
    curId: {
      type: Number,
    },
  },
  components: {
    SimilarQuery,
    mavonEditor,
  },
  data() {
    return {
      curQueryObj: {
        id: 5,
        title: "",
        categoryId: 2,
        categoryName: "",
        createDate: "",
        updatedDate: "",
        top: false,
        readCount: 0,
        likesNum: 0,
        content: "",
      },
      similarList: [],
      isLikes: false,
      isUseless: false,
      clickLikeBtn: debounce(
        (id, type) => {
          this.handleOption(id, type);
          // console.log(id);
        },
        500
      ),
      externalLink: {
        markdown_css: function() {
          // 这是markdown css文件路径
          return '/cdn-lib/markdownCss/github-markdown.min.css'
        },
        hljs_js: function() {
          // 这是hljs文件路径
          return '/cdn-lib/highlight/highlight.min.js'
        },
        katex_css: function() {
          // 这是katex配色方案路径路径
          return '/cdn-lib/KaTex/katex.min.css'
        },
        katex_js: function() {
          // 这是katex.js路径
          return '/cdn-lib/KaTex/katex.min.js'
        },
        hljs_css: function(css) {
          // 这是你的代码高亮配色文件路径
          return '/cdn-lib/highlight/styles/' + css + '.min.css';
        },
        hljs_lang: function(lang) {
          // 这是你的代码高亮语言解析路径
          return '/cdn-lib/highlight/languages/' + lang + '.min.js';
        },
      }
    };
  },
  created() {
    this.getCurQuery(this.curId);
  },
  methods: {
    getCurQuery(id) {
      getDetailInfo(id).then((res) => {
        try {
          if (res.data) {
            this.curQueryObj = res.data.detail || {};
            this.similarList = res.data.similarList || [];
            this.isLikes = res.data.detail.like;
            this.isUseless = res.data.detail.unLike;
          }
          let cookieNickName = getCookie("nickName");
          let cookieLoginKey = getCookie('loginKey');
          if (cookieNickName && cookieLoginKey && res.data.detail.noLoginRead == "0") {
            this.createWatermark(unescape(cookieNickName) + '  ' + this.getCurrentDate());
          }
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },
    getCurrentDate(){
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    createWatermark(text){
      const watermark = document.getElementById('watermark');

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 计算文本的宽度
      const textWidth = ctx.measureText(text).width;

      canvas.width = textWidth + 300;
      canvas.height = textWidth + 100;
      ctx.font = `20px Arial`;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
      ctx.rotate(-30 * Math.PI / 180);

      // 绘制水印
      ctx.fillText(text, 0, canvas.height);

      watermark.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
    },
    handleToDetail(id) {
      this.$emit("toDetail", id);
    },
    // 处理 有帮助/无帮助 按钮逻辑
    handleOption(id, type) {
      if(type === "like") {
        this.handleLikes(id);
      }else if(type === "useless") {
        this.hadleUseless(id);
      }else {
        this.$error({
          title: "操作类型错误！"
        });
      }
    },
    /**
     * 点赞
     */
    handleLikes(id) {
      console.log(id);

      // 判断该操作是 点赞 还是 取消点赞
      var option = !this.isLikes ? "add" : "subtract";
      setLikesOrCancel(id, option, "like").then((res) => {
        if (res.code != 0) {
          return;
        }
        try {
          var likeNum = res.data.likesNum ? JSON.parse(JSON.stringify(res.data.likesNum)) : 0;
          var useless = res.data.useless ? JSON.parse(JSON.stringify(res.data.useless)) : 0;

          this.curQueryObj.likesNum = likeNum;
          this.curQueryObj.useless = useless;
          this.isLikes = !this.isLikes;
          this.isUseless = false;
          this.$emit("likesAdd", id, likeNum);
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },
    // 无帮助
    hadleUseless(id) {
      console.log(id);
      // 判断该操作是 无帮助 还是 取消无帮助
      var option = !this.isUseless ? "add" : "subtract";
      setLikesOrCancel(id, option, "useless").then((res) => {
        if (res.code != 0) {
          return;
        }
        try {
          var likeNum = res.data.likesNum ? JSON.parse(JSON.stringify(res.data.likesNum)) : 0;
          var useless = res.data.useless ? JSON.parse(JSON.stringify(res.data.useless)) : 0;

          this.curQueryObj.likesNum = likeNum;
          this.curQueryObj.useless = useless;
          this.isUseless = !this.isUseless;
          this.isLikes = false;
          this.$emit("likesAdd", id, likeNum);
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },
    // 复制分享链接
    copyLink() {
      if (this.curQueryObj.shareUrl) {
        var originUrl = window.location.href ? window.location.href : "";
        var index = originUrl.indexOf("#");
        originUrl = originUrl.slice(0, index + 1);
        var copyUrl = this.curQueryObj.title + "\n" + originUrl + this.curQueryObj.shareUrl;
        this.$copyText(decodeURIComponent(copyUrl))
          .then(() => {
            this.$success({ title: "已成功复制到剪切板" });
          })
          .catch(() => {
            this.$error({ title: "复制失败" });
          });
      } else {
        this.$warning({ title: "链接不存在！" });
      }
    },
    // 反馈无帮助
    feedback() {
      let cookie = getCookie('loginKey');
      if (!cookie) {
          // this.$warning({ content: '未登录，无法使用问题反馈功能，请先登录！'})
          this.$confirm({
              title: '无法使用问题反馈',
              content: '未登录，无法使用问题反馈功能，请先登录',
              okText: '去登录',
              cancelText: '取消',
              onOk: ()=> {
                  // this.$router.push({name: 'login', query: { fromType: 'send' }})
                  this.$toLogin();
              }
          })
          return;
      }
      this.$router.push({name: 'sendQuestion'})
      // window.open("https://pro.formtalk.net/pub.do?f=5519102C16ABEF31367C86AA9E9302FC237CCBE9A79969CC5697058C98477B32");
    }
  },
  computed: {
    mainSpan() {
      return this.similarList.length ? 17 : 24;
    },
  },
  watch: {
    curId(value) {
      this.getCurQuery(value);
    },
  },
};
</script>
<style scoped>
.modal-main-content {
  /* display: inline-block; */
  /* min-width: 400px; */
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  height: 100%;
  background: #ffffff;
  border-radius: 4px;
  height: 100%;
}
.top-content {
  display: flex;
  flex-direction: column;
  display: flex;
  height: calc(100% - 30px);
}
.modal-right-content {
  display: inline-block;
  min-width: 120px;
  margin-top: 12px;
}
.ant-row-flex {
  height: 100%;
  flex-wrap: nowrap;
}
.top h2 {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 28px;
  color: #111111;
  letter-spacing: 0;
  overflow: hidden;
  /* white-space: nowrap;
  text-overflow: ellipsis; */
}
.info-row {
  height: 22px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #8c8c8c;
  letter-spacing: 0;
}
.info-item {
  margin-right: 30px;
}
.content {
  /* height: calc(100% - 176px); */
  overflow: auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  line-height: 30px;
}
::v-deep .v-note-wrapper {
  border: none;
}
.operation-row {
  margin-top: 40px;
  position: absolute;
  bottom: 0;
}
.useful,
.useless {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  cursor: pointer;
}
.useful:hover {
  color: #0077ff;
}
.useless:hover {
  color: #faad14;
}
::v-deep .v-note-wrapper {
  z-index: 900;
}
::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 20px 25px 15px 0;
}
@media screen and (max-width: 1024px) {
  .modal-right-content {
    display: none;
  }
  .category {
    display: none;
  }
  .info-item {
    margin-right: 10px;
  }
  ::v-deep .ant-col-17 {
    width: 100%;
  }
  ::v-deep .ant-btn {
    padding: 0 2px;
  }
  ::v-deep .ant-space-item {
    margin-right: 2px !important;
  }
}
@media screen and (max-width: 720px) {
    .info-item {
    margin-right: 5px;
  }
}
.watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
  overflow: hidden;
}

</style>